import { is } from '@common/is/is'
import { Object } from '@common/Object/Object'

/**
 * Az object összes string értékét lowerCase-eljük és Trimmeljük, a 3rd party működése miat.
 * @param obj - Object.
 */
export default function convertValues (obj: TAnyObject): void {
  const keys = Object.getKeys(obj)

  keys.forEach((key) => {
    const val = obj[key]

    if (is.string(val)) {
      obj[key] = val.toLowerCase().trim()
    }

    if (is.object(val)) {
      convertValues(val)
    }
  })
}
